export default "__VITE_ASSET__8dc4d101__"